$bog_ainews_app_settings $bog_ainews_app_page
	current_language \
	langs_list *
		ru \Russian
		en \English
		de \Deutsch
	title @ \Settings
	Logo $mol_icon_settings
	install? null
	install_ios_instruction @ \To install on iPhone/iPad: 1. Tap the Share button (⎙) in Safari 2. Scroll down and tap "Add to Home Screen" 3. Tap "Add"
	install_chrome_instruction @ \To install on PC: 1. Click the install icon ⊕ in the address bar (right side) 2. Or open Chrome menu (⋮) → "Install app..."
	install_edge_instruction @ \To install on PC: 1. Click the install icon ⊕ in the address bar (right side) 2. Or open Edge menu (⋯) → Apps → "Install this site as an app"
	install_unsupported_browser @ \To install this app, please use Chrome or Edge browser
	install_already_installed @ \App is already installed or not supported
	body /
		<= Interface_language_labeler $mol_labeler
			title @ \Interface language
			content /
				<= Interface_language_select $mol_locale_select
					dictionary *
						ru \Russian
						en \English
						de \Deutsch
		<= Translate_to_labeler $mol_labeler
			title @ \Translate post to
			content /
				<= Translate_to_select $mol_select
					value? <=> current_language_code? \ru
					dictionary <= langs_list
		<= Localization_labeler $mol_labeler
			title @ \Localization
			content /
				<= Auto_translate $mol_check_box
					title @ \Auto translate post to selected language
					checked? <=> is_enable_auto_translate? true
		<= Description_count_limiter_labeler $mol_labeler
			title @ \Limit description lenght
			content /
				<= Description_count_limiter $mol_number
					value? <=> description_count_limiter_value? 256
					precision_change 20
					value_min 20
		- <= Font_size_labeler $mol_labeler
			title @ \Font size
			content /
				<= Font_size_number $mol_number
					value? <=> font_size_value? 1.2
					precision_change 0.1
					precision 0.1
					value_min 0.1
		<= Spoilers_labeler $mol_labeler
			title @ \Common options
			content / <= Spoilers_labeler_list $mol_list rows /
				<= Auto_open_spoiler_check_box $mol_check_box
					title @ \Auto open post spoilers ?
					checked? <=> auto_open_spoiler_check_box_value? false
				<= Open_links_in_new_tabs_check_box $mol_check_box
					title @ \Open post links in new tab ?
					checked? <=> open_links_in_new_tabs_check_box_value? true
		<= Install_labeler $mol_labeler
			title @ \Install app
			content /
				<= Install_button $mol_button_major
					title @ \Add to Home Screen
					click? <=> install?
